if (!customElements.get('natyoure-instagram')) {
  customElements.define('natyoure-instagram', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.videos = [...this.querySelectorAll('video')];
      this.querySelectorAll('.nt-instagram__item').forEach(item => {
        const button = item.querySelector('[data-video-url]');
        const video = item.querySelector('video');
        const error = item.querySelector('.nt-instagram__error');
        button.addEventListener('click', () => {
          error.hidden = true;
          if (!video.getAttribute('src')) video.src = button.dataset.videoUrl;
          button.hidden = true;
          video.hidden = false;
          video.focus({ preventScroll: true });
          video.play().catch(() => {});
        }, options);
        video.addEventListener('play', () => {
          document.querySelectorAll('natyoure-instagram video').forEach(other => {
            if (other !== video) other.pause();
          });
        }, options);
        video.addEventListener('error', () => { error.hidden = false; }, options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
        }, { threshold: 0.1 });
        this.videos.forEach(video => this.observer.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.videos?.forEach(video => {
        video.pause();
        if (video.getAttribute('src')) {
          video.removeAttribute('src');
          video.load();
        }
      });
    }
  });
}
